// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1PzQo","selected":"Chip_selected__2SCxM"};